import {
  GET_SYMPTOMS_LIST,
  GET_SYMPTOMS_LIST_SUCCESS,
  GET_SYMPTOMS_LIST_FAILURE,
} from 'store/symptomsList/symptomsListAction';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getSymptomsListReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_SYMPTOMS_LIST:
      return { ...state, loading: true };
    case GET_SYMPTOMS_LIST_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_SYMPTOMS_LIST_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getSymptomsListReducer;
